import client from './client';
import instance from 'services/api';

// Current MMS menu selling prices for a set of inventory product UUIDs. This
// hits api01 (not the inventory backend) because the selling price lives in
// orders.co-mms. Returns a map: { [inventoryUuid]: price }.
export const getMenuPricesByInventoryUuids = (uuids) =>
  instance
    .post('/products/prices/by-inventory-uuids', { uuids })
    .then((r) => r?.data?.data?.prices || {});

export const getProducts = (params) =>
  client.get('/products', { params }).then((r) => r.data);

export const getProduct = (uuid) =>
  client.get(`/products/uuid/${uuid}`).then((r) => r.data);

export const getProductBySku = (sku) =>
  client.get(`/products/${sku}`).then((r) => r.data);

export const createProduct = (data) =>
  client.post('/products', data).then((r) => r.data);

export const bulkCreateProducts = (products) =>
  client.post('/products/bulk', { products }).then((r) => r.data);

export const updateProduct = (uuid, data) =>
  client.patch(`/products/uuid/${uuid}`, data).then((r) => r.data);

export const deleteProduct = (uuid) =>
  client.delete(`/products/uuid/${uuid}`).then((r) => r.data);

export const updateStock = (sku, data) =>
  client.patch(`/products/${sku}/stock`, data).then((r) => r.data);

export const getLowStockProducts = (businessUuid) =>
  client
    .get('/products/low-stock', {
      params: businessUuid ? { businessUuid } : undefined,
    })
    .then((r) => r.data);

export const linkIngredient = (uuid, data) =>
  client.post(`/products/${uuid}/ingredients`, data).then((r) => r.data);

export const unlinkIngredient = (productSku, ingredientSku) =>
  client
    .delete(`/products/${productSku}/ingredients/${ingredientSku}`)
    .then((r) => r.data);

export const searchProducts = (q, limit) =>
  client.get('/products/search', { params: { q, limit } }).then((r) => r.data);

export const matchProducts = (skus, barcodes, names, businessUuid) =>
  client
    .post('/products/match', { skus, barcodes, names, businessUuid })
    .then((r) => r.data);

// The unitPrice each linked line would leave on its product, computed by the
// same cost rules the invoice and bulk-import writes use.
// `lines`: [{ productUuid, costMode, unitCost, quantity }].
// Returns [{ productUuid, currentCost, newCost }] in the same order.
export const previewProductCost = (lines) =>
  client.post('/products/cost-preview', { lines }).then((r) => r.data);

export const getProductByBarcode = (barcode) =>
  client.get(`/products/barcode/${barcode}`).then((r) => r.data);

export const getProductStats = (businessUuid) =>
  client
    .get('/products/stats', {
      params: businessUuid ? { businessUuid } : undefined,
    })
    .then((r) => r.data);

export const getProductsPaginated = (params) =>
  client.get('/products/paginated', { params }).then((r) => r.data);
